import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import CopilotAgentTabs from "./CopilotAgentTabs";
import CopilotChat from "./CopilotChat";
import { useCopilotShell } from "./CopilotShellContext";
import { formatWorkingWithLabel } from "./copilotUtils";
import "./Copilot.scss";

const CopilotDrawer = () => {
  const navigate = useNavigate();
  const {
    drawerVisible,
    closeDrawer,
    pageContext,
    threads: threadApi,
    canUseDebug,
  } = useCopilotShell();
  const {
    threads,
    activeThreadId,
    setActiveThreadId,
    createThread,
    deleteThread,
    clearAllThreads,
  } = threadApi;

  return (
    <Dialog
      visible={drawerVisible}
      onHide={closeDrawer}
      className="copilot-dialog"
      maskClassName="copilot-dialog-mask"
      showHeader={false}
      dismissableMask
      resizable={false}
      draggable={false}
      style={{ width: "480px", maxWidth: "95vw" }}
    >
      <div className="copilot-drawer__shell">
        <div className="copilot-drawer__header">
          <div className="copilot-drawer__brand">
            <span className="copilot-drawer__logo">
              <i className="pi pi-sparkles" />
            </span>
            <div>
              <h3>MolAssist</h3>
              <p className="copilot-drawer__subtitle">AI assistant for recruitment</p>
            </div>
          </div>
          <div className="copilot-drawer__header-actions">
            {canUseDebug ? (
              <Button
                type="button"
                icon="pi pi-wrench"
                className="p-button-text p-button-sm"
                tooltip="Open workspace in debug / smoke mode"
                tooltipOptions={{ position: "left" }}
                aria-label="Open debug and smoke tests"
                onClick={() => {
                  closeDrawer();
                  navigate("/recruitment-ai-assistant?debug=1");
                }}
              />
            ) : null}
            <Button
              type="button"
              icon="pi pi-external-link"
              className="p-button-text p-button-sm"
              tooltip="Expand full workspace"
              tooltipOptions={{ position: "left" }}
              onClick={() => {
                closeDrawer();
                navigate("/recruitment-ai-assistant");
              }}
            />
            <Button
              type="button"
              icon="pi pi-times"
              className="p-button-text p-button-sm"
              onClick={closeDrawer}
              aria-label="Close MolAssist"
            />
          </div>
        </div>

        {pageContext?.entityType ? (
          <div className="copilot-drawer__context">
            <i className="pi pi-map-marker" />
            <span>{formatWorkingWithLabel(pageContext)}</span>
          </div>
        ) : null}

        <CopilotAgentTabs
          threads={threads}
          activeThreadId={activeThreadId}
          onSelect={setActiveThreadId}
          onNewChat={createThread}
          onDeleteThread={deleteThread}
          onClearAll={clearAllThreads}
          variant="drawer"
        />

        <div className="copilot-drawer__body copilot-drawer__body--tabs">
          <div className="copilot-drawer__chat">
            <CopilotChat compact />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default CopilotDrawer;
